import { inject } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { withRouter, useLocation, useHistory } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import { rootStore } from '../../mobx/store'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import strings from '../../lang/strings'
import PageSubHeader from '../../components/common/page_sub_header'
import TableHeader from '../../components/control/table/table_header'
import TabHeader from '../../components/control/table/tab_header'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ReactPaginate from 'react-paginate'
import { formatNumber, string } from '../../helper/common'
import { tabInfo } from '../../config/constTable'
import DropdownRegister from '../../components/dropdown/register_drop'
import { BjTableRows, DailyTableRows } from '../../components/table/winee_table'
import { requestBjDataBuy } from '../../helper/business'
import useIsMobile from '../../hooks/useIsMobile'
import { BjTableCard } from '../../components/card/winee_card'

const WineeDataList = (props) => {
  const location = useLocation();
  const history = useHistory();
  const isMobile = useIsMobile();

  const getInitialTabIndex = () => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');

    switch (tab) {
      case 'pm':
        return 0;
      case 'special':
        return 1;
      default:
        return 0; // 기본값
    }
  };

  const context = useContext(Page_settings)
  const tabList = [tabInfo.bjGameArticle, tabInfo.bjGameSpecial]
  const [tabIndex, setTabIndex] = useState(getInitialTabIndex);
  let [dataList, setDataList] = useState(Array.from({ length: tabList.length }, () => []))
  let [totalCount, setTotalCount] = useState(Array.from({ length: tabList.length }, () => 0))
  let [pageCount, setPageCount] = useState(Array.from({ length: tabList.length }, () => 1))
  let [page, setPage] = useState(Array.from({ length: tabList.length }, () => 1))

  let [yearList, setYearList] = useState([])
  let [roundList, setRoundList] = useState([])
  let [kindList, setKindList] = useState([])
  let [roundListAll, setRoundListAll] = useState([])
  let [year, setYear] = useState(0)
  let [round, setRound] = useState(0)
  let [kind, setKind] = useState(0)
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

  const PAGECOUNT = 20

  useEffect(() => {
    // initPicker()
  }, [])

  useEffect(() => {
    const tabValue = tabIndex === 0 ? 'analysis' : 'special';
    const params = new URLSearchParams(location.search);
    params.set('tab', tabValue);
    history.replace({ search: params.toString() });
    getData(1, tabIndex, 0, 0, 0)
    // if (tabList[tabIndex].table_type !== "daily") return
    // context.checkDailyPopup()
  }, [tabIndex])

  const initPicker = () => {
    context.post('data/sport_list_all', {},
      response => {
        setYearList(response.year)
        setRoundListAll(response.round)
        setKindList(response.kind)
      }
    )
  }

  const selectYear = (year) => {
    setYear(year)
    setRound(0)
    const roundL = roundListAll.filter((item) => { return item.year == year })
    if (roundL.length === 0 || roundL[0].round.length === 0) {
      setRoundList([])
      return
    }
    setRoundList(roundL[0].round)
    initData(year, 0, kind)
  }

  const initData = (year, round, kind) => {
    for (let i = 2; i < 6; i++) {
      setPage(prev => prev.map((it, idx) => { return idx === i ? 1 : it }))
      getData(1, i, year, round, kind)
    }
  }

  const getData = (page, index, year, round, kind) => {
    let data = { cate: tabList[index].cate, page: page, count: PAGECOUNT }
    if (tabList[index].betting) {
      data.is_betting = 1;
    }
    if (index >= 2) {
      //data.year = year
      //data.round = round
      //data.kind = kind
    }
    context.post('data/data_list', data,
      response => {
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
        setDataList(prev => prev.map((it, idx) => { return idx === index ? response.list : it }))
        setTotalCount(prev => prev.map((it, idx) => { return idx === index ? response.cnt : it }))
        setPageCount(prev => prev.map((it, idx) => { return idx === index ? response.page_count : it }))
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const goResult = (result) => {
    props.history.push(tabList[tabIndex].url, { result: result })
  }

  const onResultAnalyst = (result, price) => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }

    if (result.is_readable == 0) {
      context.showAlert(strings.data_disabled)
      return
    }

    if (result.is_purchased == 0) {
      if (result.is_free == 1) {
        context.post('pay/andata_buy', { dat_id: result.dat_id },
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => { context.showAlert(err.msg) }, 500)
          }
        )
        return;
      }


      context.showPointUse(result.mb_nick, price, () => {
        const mb_point = rootStore.getMe.mb_point
        if (Number(mb_point) < Number(price)) {
          context.showPointLack(1, price, () => {
            context.showPointPay()
          })
          return
        }
        context.post('pay/andata_buy', { dat_id: result.dat_id },
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => { context.showAlert(err.msg) }, 500)
          }
        )
      })
      return
    }
    goResult(result)
  }

  const onResultBj = (result) => {
    requestBjDataBuy(context, result, props, () => goResult(result));
    return;
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(prev => prev.map((it, idx) => { return idx === tabIndex ? nextPage : it }))
    getData(nextPage, tabIndex, year, round, kind)

    if (isMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.body.scrollTop = 0;       // Safari fallback
      document.documentElement.scrollTop = 0; // Chrome, Firefox fallback
    }
  }

  const onNew = (idx) => {
    let urls = ['/my_data/analyst_new_game', '/my_data/analyst_new_betting', '/my_data/analyst_new_victory', '/my_data/analyst_new_daily', '/my_data/bj_new/0', '/my_data/bj_new/1', '/my_data/bj_new']
    props.history.push(urls[idx], { data: null })
  }

  const onBJDetail = (item) => {
    if (item.mb_lv < 4) {
      context.post('data/an_list', { an_id: item.mb_id },
        response => {
          const mb = response.an
          if (mb != null) props.history.push('/analyst/detail', { info: mb, wineeList: response.winee_list })
        }
      )
    } else {
      context.post('data/bj_list', { bj_id: item.mb_id },
        response => {
          const mb = response.bj
          if (mb != null) props.history.push(`/bj/detail/${mb.mb_id}`, { bjList: response.bj_list })
        }
      )
    }
  }


  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.data_all} pageMenu1={strings.home} pageMenu2={strings.wn_data} pageMenu={tabList[tabIndex].title} />
          <div className='mt-30 sm-mt-15 d-flex justify-content-center align-items-center sm-block'>
            <div className='fs-18 sm-fs-16 f-b flex-full'>{string.Format(strings.data_page1, formatNumber(totalCount[tabIndex]))}<span className='ml-15'>{string.Format(strings.data_page2, formatNumber(page[tabIndex]), formatNumber(pageCount[tabIndex]))}</span></div>
            {rootStore.isSignedIn && rootStore.getMe.mb_lv > 1 &&
              <DropdownRegister onRegister={(idx) => { onNew(idx) }} />
            }
            <div className={'d-flex justify-content-end invisible'} style={{ width: 0 }}>
              <select className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb bg-white' value={year} onChange={(e) => { selectYear(e.target.value) }}>
                <option value={0}>{strings.all}</option>
                {yearList.map((it, idx) => { return (<option value={it.year} key={idx}>{it.year}{strings.year}</option>) })}
              </select>
              <select className='data-filter-select mh-60 sm-mh-12 pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb bg-white' value={round} onChange={(e) => { setRound(e.target.value); initData(year, e.target.value, kind) }}>
                <option value={0}>{strings.all}</option>
                {roundList.map((it, idx) => { return (<option value={it.round} key={idx}>{it.round}{strings.times}</option>) })}
              </select>
              <select className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb bg-white' value={kind} onChange={(e) => { setKind(e.target.value); initData(year, round, e.target.value) }}>
                <option value={0}>{strings.all}</option>
                {kindList.map((it, idx) => { return (<option value={it.sk_id} key={idx}>{it.sk_name}</option>) })}
              </select>
            </div>
          </div>
          <TabHeader className={'mt-20 sm-none'} selected={tabIndex} tabs={tabList.map(item => item.customTitle || item.title)} onChange={(id) => { setTabIndex(id) }} />
          <select className='form-control hx-64 sm-mt-15 sm-inherit custom_select' value={tabIndex} onChange={(e) => { setTabIndex(parseInt(e.target.value)) }}>
            {tabList.map((it, idx) => { return (<option value={idx} key={idx}>{it.title}</option>) })}
          </select>
          {tabList.map((it, idx) => {
            return (
              <div key={idx} className={tabIndex === idx ? '' : 'hide'}>
                <div className='shadow-div position-relative'>
                  {
                    isMobile ?

                      <div className='sm-mt-20 mb-40'>
                        <BjTableCard
                          header={it.header}
                          data={dataList[idx]}
                          onBJClick={onBJDetail}
                          onTitleClick={onResultBj}
                          rowClick={false}
                        />

                      </div>

                      :
                      <PerfectScrollbar className='tb-sale sm-mt-20 mb-40'>
                        <TableHeader className={'bg-white'} headers={it.header} />
                        {
                          it.table_type === "bj" &&

                          <BjTableRows
                            header={it.header}
                            data={dataList[idx]}
                            onBJClick={onBJDetail}
                            onTitleClick={onResultBj}
                            rowClick={false}
                          />

                        }
                        {
                          it.table_type === "daily" &&
                          <DailyTableRows
                            header={it.header}
                            data={dataList[idx]}
                            onBJClick={onBJDetail}
                            onTitleClick={onResultAnalyst}
                            rowClick={false}
                          />
                        }
                      </PerfectScrollbar>

                  }
                </div>
                {pageCount[idx] > 1 &&
                  <ReactPaginate
                    previousLabel={''}
                    nextLabel={''}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pageCount[idx]}
                    marginPagesDisplayed={isMobile ? 1 : 2}
                    pageRangeDisplayed={isMobile ? 3 : 5}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                }
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(WineeDataList))
